import { DrfqLeg } from '#/unified-rfqs/entities/drfq/domain';
import { NullableTwoWay, TwoWayValue } from '../form-reducer';

interface ValidationViewArgs {
  readonly quantity: string;
  readonly price: TwoWayValue;
  readonly legPricingEnabled: boolean;
  readonly legsPrice: readonly NullableTwoWay[];
  readonly legs: readonly DrfqLeg[];
  readonly productCode: string | undefined;
}

export default function validationView({
  quantity,
  productCode,
  legsPrice,
  legs,
  price,
  legPricingEnabled,
}: ValidationViewArgs) {
  const hasBuyPrice = price[0] !== '';
  const hasSellPrice = price[1] !== '';

  let isBuyPriceValid = true;
  if (hasBuyPrice) {
    isBuyPriceValid = legPricingEnabled
      ? isLegPricesValid(legsPrice, legs, 'BUY')
      : isValidFloat(price[0]);
  }

  let isSellPriceValid = true;
  if (hasSellPrice) {
    isSellPriceValid = legPricingEnabled
      ? isLegPricesValid(legsPrice, legs, 'SELL')
      : isValidFloat(price[1]);
  }

  return {
    price: isBuyPriceValid && isSellPriceValid,
    quantity: isValidQuantity(quantity, productCode),
  };
}

function isValidQuantity(value: string, productCode: string | undefined) {
  if (productCode == null || !isValidFloat(value) || !isPositive(value))
    return false;
  return true;
}

function isValidFloat(value: string): boolean {
  return Number.isFinite(Number.parseFloat(value));
}

export function isPositive(value: string): boolean {
  return Number.parseFloat(value) > 0;
}

function isValidLegPrice(value: string | null) {
  return value != null && isValidFloat(value) && isPositive(value);
}

function isLegPricesValid(
  legPrices: readonly NullableTwoWay[],
  legs: readonly DrfqLeg[],
  side: 'BUY' | 'SELL',
) {
  return legPrices.every((legPrice, index) => {
    const leg = legs[index]!;
    return isValidLegPrice(legPrice[leg.side === side ? 0 : 1]);
  });
}
